import { render, staticRenderFns } from "./EmployeeSelectorModal.vue?vue&type=template&id=674d4a58&scoped=true&"
import script from "./EmployeeSelectorModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeSelectorModal.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSelectorModal.vue?vue&type=style&index=0&id=674d4a58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d4a58",
  null
  
)

export default component.exports